import Param from '../param';
import Util from './libs/util';

let param = new Param();
let util = new Util();

export default class effectManager {
    constructor(){
        this.$svgTarget = $(".js__tsc-svg-write,.js__svg-write");
        /* 低スペック端末用の分岐 */
        this.type = Useragnt.ie||Useragnt.tablet ? "low" : "normal";


    }
    /* グロナビやモーダルなど表示した際に使用する */
    show($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:400,z:2});


        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                x:-400,
                z:-2,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    x:400,
                    z:2
                },
                {
                x:0,
                z:0,
                // ease: "Power2.easeInOut",
                ease: "Expo.easeInOut",
            },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                delay:0.3,
                // scale:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }
    /* スクロールに連動して表示させる際に使用する */
    scShow($target,type){

        if(type==="set"){

            if(param.displayType === 'sp'){
                TweenMax.set($target,{ opacity:0, x:300,z:2});
            }else{
                if(this.type=="low"){
                    TweenMax.set($target,{ opacity:0, x:800});
                }else{
                    TweenMax.set($target,{ opacity:0, x:800,z:2});
                }
            }

        }else if(type==="out"){
            if(param.displayType === 'sp'){
                TweenMax.staggerTo($target,0.4, {
                    x:-300,
                    z:-2,
                    opacity:0,
                    ease: "Power2.easeIn",
                },0.05);
            }else{
                if(this.type=="low"){
                    TweenMax.staggerTo($target,0.6, {
                        x:-800,
                        opacity:0,
                        ease: "Power2.easeIn",
                    },0.05);
                }else{
                    TweenMax.staggerTo($target,0.6, {
                        x:-800,
                        opacity:0,
                        ease: "Power2.easeIn",
                    },0.05);
                }
            }
        }else{

            if(param.displayType === 'sp' || !$('body#top')[0]){
                TweenMax.staggerFromTo($target,0.8,
                    {
                        x:300,
                        z:2
                    },
                    {
                        x:0,
                        z:0,
                        ease: "Power2.easeOut",
                        // ease: "Expo.easeInOut",
                    },0.1);
                TweenMax.staggerTo($target,0.5, {
                    opacity:1,
                    // delay:0.3,
                    // scale:1,
                    ease: "Power2.easeIn",
                },0.1);
            }else{
                if(this.type=="low"){
                    TweenMax.staggerFromTo($target,1.8,
                        {
                            x:800,
                        },
                        {
                            x:0,
                            ease: "Power2.easeOut",
                        },0.1);
                }else{
                    TweenMax.staggerFromTo($target,1.8,
                        {
                            x:800,
                            z:2
                        },
                        {
                            x:0,
                            z:0,
                            ease: "Power2.easeOut",
                        },0.1);
                }
                TweenMax.staggerTo($target,0.7, {
                    opacity:1,
                    // delay:0.3,
                    // scale:1,
                    ease: "Power2.easeIn",
                },0.1);
            }

        }

    }
    /* スクロールに連動して表示させる際に使用する（ゆっくりver） */
    scShowSlow($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, x:200,z:2});

        }else if(type==="out"){
            TweenMax.staggerTo($target,0.4, {
                x:-200,
                z:-2,
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerFromTo($target,1.4,
                {
                    x:200,
                    z:2
                },
                {
                    x:0,
                    z:0,
                    ease: "Power2.easeOut",
                    // ease: "Expo.easeInOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }
    /* X軸にランダムでパネルを表示させる */
    bg($target,type){

        if(type==="set"){

            TweenMax.set($target,{ x:-101+"%"});


        }else if(type==="showset"){

            TweenMax.set($target,{ x:0+"%"});


        }else if(type==="out"){

            for(let i=0; i<$target.length; i++){

                TweenMax.to($target.eq(i),0.9, {
                    x:101+"%",
                    // z:0,
                    delay : 0.1 * util.random(0,6),
                    ease: "Power2.easeInOut",
                    // ease: "SlowMo.ease.config(0.5, 0.7, false)",
                },0.1);

            }

        }else{

            for(let i=0; i<$target.length; i++){

                TweenMax.fromTo($target.eq(i),0.9,
                    {
                        x : -101+"%"
                    },
                    {
                    x:0+"%",
                    // z:0,
                    delay : 0.1 * util.random(0,6),
                    ease: "Power2.easeInOut",
                    // ease: "SlowMo.ease.config(0.5, 0.7, false)",
                },0.1);

            }

        }

    }
    /* 写真の表示用 */
    bgImg($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0,scale:1.2});


        }else if(type==="out"){

            TweenMax.to($target,0.4, {
                opacity:0,
                // z:1,
                scale:1.2,
                // z:0,
                ease: "Power2.easeIn",
            },0.1);


        }else{

            TweenMax.to($target,0.9, {
                opacity:1,
                // z:0,
                ease: "Power2.easeInOut",
            },0.1);

            TweenMax.to($target,10.0, {
                scale:1,
                // z:0,
                ease: "Power2.easeOut",
            },0.1);

        }

    }
    /* 閉じるボタン */
    closeBtn($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0, scale:0.4,rotation:360});


        }else if(type==="out"){
            TweenMax.killTweensOf($target);
            TweenMax.to($target,0.6, {
                opacity:0,
                scale:0.4,
                rotation:-360,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.fromTo($target,0.8,
                {
                    scale:0.4,
                    rotation:360
                },
                {
                    opacity:1,
                    scale:1,
                    rotation:0,
                    ease: "Power2.easeOut",
                    // ease: "Expo.easeInOut",
                },0.1);
            TweenMax.to($target,0.7, {
                opacity:1,
                delay:0.3,
                // scale:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }
    /* ビジネスのきr変え */
    op($target,type){

        if(type==="set"){

            TweenMax.set($target,{ opacity:0,z:2});


        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                z:-2,
                ease: "Power2.easeIn",
            },0.05);
            TweenMax.staggerTo($target,0.4, {
                opacity:0,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    z:2
                },
                {
                    z:0,
                    // ease: "Power2.easeInOut",
                    ease: "Expo.easeInOut",
                },0.1);
            TweenMax.staggerTo($target,0.7, {
                opacity:1,
                delay:0.3,
                // scale:1,
                ease: "Power2.easeIn",
            },0.1);

        }

    }

    splitText($target,type){


        if($target.length == 0){
          // console.log('element not exist');
          return;
        }

        if(type === "set"){

            for(let i=0; i<$target.length; i++){
                let _$t = $target.eq(i);
                let text = new SplitText(_$t, {type:"words,chars"}),
                    chars = text.chars;
                if(_$t.hasClass("js__type-right")){
                    TweenMax.set(chars,{ opacity:0, x:-400,z:1});
                }else{
                    TweenMax.set(chars,{ opacity:0, x:400,z:1});
                }
            }

        }else if(type === "out"){
            TweenMax.killChildTweensOf($target.parent().parent());
            if($target.hasClass("js__type-right")){
                TweenMax.staggerTo($target, 0.1,
                    {
                        opacity:0, x:400,
                        // filter:"blur(0px)",
                        ease: "Power2.easeIn",
                    },
                    0.005
                );
            }else{
                TweenMax.staggerTo($target, 0.4,
                    {
                        opacity:0, x:-400,
                        // filter:"blur(0px)",
                        ease: "Power2.easeIn",
                    },
                    0.01
                );
            }
        }else{
            TweenMax.killTweensOf($target);
            TweenMax.staggerTo($target, 0.6,
                {
                    opacity:1,
                    // filter:"blur(0px)",
                    ease: "Power2.easeOut",
                },
                0.05
            );
            TweenMax.staggerTo($target, 0.6,
                {
                    x:0,
                    // opacity:1,
                    z:1,
                    // rotationY:0,
                    // filter:"blur(0px)",
                    // ease: "SlowMo.ease.config(0.7, 0.7, false)",
                    ease: "Power2.easeOut",
                },
                0.05
            );
        }

    }
    panel($target,type){

        if(type==="set"){

            TweenMax.set($target,{ x:100+"%"});


        }else if(type==="out"){
            TweenMax.staggerTo($target,0.6, {
                x:-100+"%",
                width:0,
                ease: "Power2.easeIn",
            },0.05);
        }else{

            TweenMax.staggerFromTo($target,1.8,
                {
                    x:100+"%",
                },
                {
                    x:0+"%",
                    ease: "Expo.easeInOut",
                },0.1);

        }
    }

    pjax(_id,type,movoType){

        let $photo = $('#p-pjax-photo');
        let $csrPhoto = $('#p-csr-content-main-photo');
        let $header = $('#l-header');

        if(type==="set"){


        }else if(type==="out"){

            if(param.displayType === 'sp'){

                if (_id === 'reuse' && $('body#top')[0]) {

                    TweenMax.set($('#p-csr-content-main .js__tsc-show,#l-pagetop,#p-kv,#p-philosophy,#p-business,#p-company'), {opacity: 0});

                    let targetElement = document.getElementById("p-csr-content-main-photo__inner");
                    let clientRect = targetElement.getBoundingClientRect();
                    let _y = clientRect.top;

                    TweenMax.set($csrPhoto.find('.p-img__inner'), {'overflow': 'visible'});
                    TweenMax.to($csrPhoto.find('.l-img'), 0.6, {
                        z: 0,
                        ease: "Power2.easeOut",
                    });
                    TweenMax.to($csrPhoto.find('.l-img'), 0.6, {
                        y: -(_y - $header.height()),
                        height: '101.33333vw',
                        ease: "Power2.easeInOut",
                        onComplete: function () {
                            $photo.css({
                                "display": "block",
                            });
                            $('html,body').animate({ scrollTop: 0 }, '1',function(){
                                TweenMax.set($('.p-lowlayer,#l-footer'), {opacity: 1});
                            });
                        }
                    });

                }

            }else {

                if (_id === 'reuse' && $('body#top')[0]){

                    this.scShow($('#p-kv,#p-philosophy,#p-business,#p-company,#p-csr-content-main .js__tsc-show,#l-pagetop'), 'out');

                    let targetElement = document.getElementById("p-csr-content-main-photo__inner");
                    let clientRect = targetElement.getBoundingClientRect();
                    let _x = clientRect.left;
                    let _h = $photo.innerHeight();

                    TweenMax.set($csrPhoto.find('.p-img__inner'), {'overflow': 'visible'});
                    TweenMax.to($csrPhoto.find('.l-img'), .3, {
                        delay:0.1,
                        z: 0,
                        ease: "Power2.easeOut",
                    });
                    TweenMax.set($csrPhoto, {className:"+=is-center"});
                    TweenMax.to($csrPhoto.find('.l-img'), 1.1, {
                        x: -(_x - $header.width()),
                        height:_h,
                        ease: "Power2.easeInOut",
                        onComplete: function () {
                            if(movoType === 'gnavi') return;
                            $photo.css({
                                "display": "block",
                                x: (_x - $header.width()),
                            });
                        }
                    });

                }else{

                }

            }

        }else{

            if(param.displayType === 'sp'){

            }else{

                if (_id === 'reuse' && $('body#reuse')[0]){

                    let targetElement = document.getElementById( "p-csr" ) ;
                    let clientRect = targetElement.getBoundingClientRect() ;
                    let _x = clientRect.left ;

                    for(let i=0; i<$photo.find('.l-img').length; i++){

                        TweenMax.to($photo.find('.l-img').eq(i),1.2, {
                            x:(_x - 100),
                            delay : 0.1 * util.random(0,6),
                            ease: "Power2.easeOut",
                        });

                    }

                }

            }

        }

    }

}
